import React from 'react';
import {Route} from "react-router-dom";
import * as innerRoutes from "./innerRoutes";
import AllWorkSpace from "./WorkSpace/AllWorkSpaces";
import WorkSpaceCalender from "./WorkSpace/WorkSpaceCalender";
import WorkSpaceGrid from "./WorkSpace/WorkSpaceGrid";
import './space_tags_style.scss';
import * as actionCreator from "../../store/Action";
import {connect} from "react-redux";

class WorkSpaceComponent extends React.Component {

  componentDidMount() {
    this.props.systemChangeHandler(5);
  }

  render() {
    return(
      <div>
        <switch>
          <Route exact path={innerRoutes.inner_route_spacetags_all_workspace} component={AllWorkSpace}/>
          <Route exact path={innerRoutes.inner_route_spacetags_workspace_calender} component={WorkSpaceCalender}/>
          <Route path={innerRoutes.inner_route_spacetags_workspace_calender_slots} component={WorkSpaceGrid}/>
        </switch>
      </div>
    )
  }

}

const mapStateToProps = (state) => ({
  usr_obj: state.userReducer.user,
});

const mapDispatchToProps = (dispatch) => {
  return {
    systemChangeHandler: (data) => dispatch(actionCreator.systemChangeHandler(data)),
  };
};

export default connect(mapStateToProps, mapDispatchToProps)(WorkSpaceComponent);
